import React, { useEffect } from "react";
import { View, Text, Image, Linking, StyleSheet, ScrollView, TouchableOpacity } from "react-native";
import { Button } from "react-native-paper";
import { useLanding } from "../../hooks/Login/useLanding";
import { LinearGradient } from 'expo-linear-gradient'; 
import { useAuthFB } from "../../context/Auth/AuthFbContext";

export default function LandingScreen() {
  const { onGooglePressed } = useLanding();
  const { loginWithGoogle } = useAuthFB();

  return (
    <ScrollView contentContainerStyle={styles.container}>
      <View style={styles.contentWrapper}>
        {/* Logo Section */}
        <View style={styles.logoContainer}>
          <Image
            source={require("../../assets/images/logo_default.png")}
            style={styles.logo}
            resizeMode="contain"
          />
          <Text style={styles.title}>Time Tracking Application</Text>
        </View>

        {/* Welcome Message */}
        <View style={styles.messageContainer}>
          <Text style={styles.message}>
            You're about to log in to the platform. Please use your Google Workspace account to continue.
          </Text>
        </View>

        {/* Google Login Button */}
        <LinearGradient 
          colors={['#8cb633', '#96c72d']}
          style={styles.gradientButton}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 1 }}
        >
          <Button
            icon="google"
            mode="contained"
            textColor="#ffffff"
             onPress={() => loginWithGoogle()}
            style={{ backgroundColor: 'transparent' }} // Important
            contentStyle={styles.googleButtonContent}
          >
            Sign in with Google
          </Button>
        </LinearGradient>

        {/* Additional Info */}
        <View style={styles.infoContainer}>
          <Text style={styles.infoText}>
            Don't have an account? Visit our{" "}
            <Text
              style={styles.link}
              onPress={() => Linking.openURL("https://ARTi.com")}
            >
              main website
            </Text>{" "}
            to learn more.
          </Text>
        </View>

        {/* Footer Links */}
        <View style={styles.footerContainer}>
          <TouchableOpacity onPress={() => Linking.openURL("https://ARTi.com")}>
            <Text style={styles.footerLink}>Website</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={() => Linking.openURL("https://gaia.arti-cloud.com/privacy-policy")}>
            <Text style={styles.footerLink}>Privacy Policy</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={() => Linking.openURL("mailto:support@guru.com.uy")}>
            <Text style={styles.footerLink}>Support</Text>
          </TouchableOpacity>
        </View>

        {/* Copyright */}
        <Text style={styles.copyright}>
          © 2025 Guru. All rights reserved.{"\n"}
        </Text>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    backgroundColor: "#ffffff",
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 20,
    paddingHorizontal: 16,
  },
  gradientButton: {
    borderRadius: 21,
    overflow: 'hidden', // This ensures the gradient respects the button's rounded corners
    marginVertical: 10,
  },
  contentWrapper: {
    width: "100%",
    maxWidth: 432,
    backgroundColor: "#fff",
    padding: 27,
    borderRadius: 21,
    elevation: 4, // Android shadow
  },
  logoContainer: {
    alignItems: "center",
    marginBottom: 24,
  },
  logo: {
    height: 60,
    width: "100%",
    marginBottom: 16,
  },
  title: {
    marginTop: 12,
    fontSize: 22,
    fontWeight: "500",
    color: "#333",
    textAlign: "center",
    textTransform: "uppercase",
  },
  messageContainer: {
    marginBottom: 24,
  },
  message: {
    fontSize: 16,
    color: "#555",
    textAlign: "center",
    lineHeight: 22,
  },
  googleButton: {
    borderRadius: 8,
    marginVertical: 8,
  },
  googleButtonContent: {
    paddingVertical: 6,
  },
  infoContainer: {
    marginTop: 20,
  },
  infoText: {
    fontSize: 14,
    color: "#666",
    textAlign: "center",
    lineHeight: 20,
  },
  link: {
    color: "#4285F4",
    textDecorationLine: "underline",
  },
  footerContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 24,
  },
  footerLink: {
    color: "#4285F4",
    fontSize: 14,
  },
  copyright: {
    textAlign: "center",
    fontSize: 12,
    color: "#999",
    marginTop: 24,
  },
});
